<template>
  <div class="pl-0">
    <div v-if="trackingTestStartTime || trackingTestStartTimeStorage">
      <div class="md:p-6 pt-6 pl-0 mt-1">
        <div class="md:flex md:float-right">
          <TestConnectionActions @test-done="getTrackingTest" @update-done="updateValues"/>
        </div>
      </div>

      <div class="clear-both"></div>
      <div class="md:pl-5 w-full">
        <div class="w-full test-status">
          <span class="conversion-verfied-title" v-if="isTrackingTestDone === $constants.TRACKING_TEST_STATUS.DONE">
            <!--  -->
            <vs-icon icon-pack="speakol" icon="speakol-verified" class="converiosn-verfied-icon verified-icon ml-2 pr-1"></vs-icon>
            {{ $t('tracking.test_connection_tab.test_done') }}
          </span>
          <span v-else>
            <!-- v-else -->
            <div class="flex processing">
              <clip-loader :loading="true" :color="'#0092D7'" :size="'18px'" class="ml-2 pr-2"></clip-loader>
              <p class="test-connections-processing w-full">{{ $t('tracking.test_connection_tab.processing_title') }}</p>
            </div>

            <div class="flex notifications-bar items-center border-speakol-color">
              <div class="flex space-x-8">
                <vs-icon icon="speakol-info flex items-center icon-info" color="#1890FF" bg="FDF5E1" icon-pack="speakol" round></vs-icon>
                <ul class="list-disc">
                  <li v-html="$t('tracking.test_connection_tab.processing_desc1')"></li>
                  <li v-html="$t('tracking.test_connection_tab.processing_desc2')"></li>
                </ul>
              </div>
            </div>
          </span>
        </div>

        <TestEventsTree
          :trackingTestResult="trackingTestResult"
          :status="isTrackingTestDone"
          :testURL="testURL"
        />
      </div>
    </div>

    <div v-else>
      <TestEventsEmptyState @update-done="updateValues"/>
    </div>
  </div>
</template>
<script>

import TestEventsTree from './TestEventsTree.vue'
import '@/validators/Tracking'
import TestConnectionActions from './TestConnectionActions.vue'
import TestEventsEmptyState from './TestEventsEmptyState.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  components: {
    TestEventsTree,
    TestConnectionActions,
    TestEventsEmptyState,
    ClipLoader
  },
  data () {
    return {
      trackingTestStartTimeStorage: null,
      timeout: (process.env.VUE_APP_PIXEL_TEST_SESSION_WINDOW || 10) * 1000,
      xCheckSeconds: (process.env.VUE_APP_PIXEL_TEST_DATA_POOL_INTERVAL || 5) * 1000,
      trackingTestResult: [],
      testURL: null,
      isTrackingTestDone: null,
      trackingTestStartTime: null,
      reinitializeRequest: false,
      testTimeout: null
    }
  },

  created () {
    this.getTrackingTest()
  },

  computed: {},

  watch: {
    trackingTestResult () {
      this.isTrackingTestDone = this.status
    }
  },

  methods: {
    updateValues (newValues) {
      this.status = newValues.status
      this.trackingTestStartTime = newValues.trackingTestStartTime
      this.debugId = newValues.debugId
      this.testURL = newValues.testURL
    },
    async requestTrackingTest () {
      if (this.trackingTestStartTime || this.trackingTestStartTimeStorage) {
        const response = await window.axios.get('/tracking/test', {
          hideLoader: true,
          params: {
            debugId: this.debugId
          }
        })

        return response.data.payload
      }
    },

    async getTrackingTest (newValues = {}) {
      const self = this
      self.trackingTestResult = []

      const interval = setInterval(async () => {
        self.trackingTestResult = await self.requestTrackingTest()

      }, self.xCheckSeconds)


      if (this.testTimeout && newValues && newValues.reinitializeRequest === true) {
        clearTimeout(this.testTimeout)
      }

      //  stop hitting api
      this.testTimeout = setTimeout(() => {
        this.status = this.$constants.TRACKING_TEST_STATUS.DONE
        this.isTrackingTestDone = this.$constants.TRACKING_TEST_STATUS.DONE
        clearInterval(interval)
      }, self.timeout)
    }
  }
}
</script>

<style scoped lang="scss">
$verifiedColor: #21ba45;
$hintBgColor: #e6f5fb;
$hintFontColor: #323232;

.verified-icon {
  font-size: 16.5px !important;
  color: $verifiedColor;
}

.conversion-verfied-title {
  color: $hintFontColor;
}

.test-status {
  margin-top: 15px;
}

.test-connections-processing {
  color: #323232;
}

.processing {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.233333px;
  color: $hintFontColor;
}

.icon-info {
  font-size: 13.4px !important;
}

.converiosn-verfied-icon {
  position: relative;
  top: 2px;
}

.notifications-bar {
  padding: 12px;
  background: $hintBgColor;
  box-sizing: border-box;
  margin-top: 18px;
  border-radius: 4px;
  border: 1px solid;
  width: 641px;
  height: 64px;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.233333px;
  color: $hintFontColor;
}

@media (max-width: 768px) {
  .test {
    padding-left: 0;
  }

  .notifications-bar {
    height: auto;
    width: auto;
  }
}
</style>
